/**
 * Storezone — Platform (Superadmin) Routes
 *
 * All routes here are wrapped in PlatformLayout and
 * require platform_role === 'superadmin'.
 *
 * Pages are lazy-loaded. Business modules will be added here
 * in future milestones.
 */

import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { PlatformLayout } from '@/layouts/PlatformLayout'
import { LoadingPage } from '@/components/states/LoadingPage'


const PlatformTenantsPage = lazy(() =>
  import('@/pages/platform/PlatformTenantsPage').then((m) => ({
    default: m.PlatformTenantsPage,
  })),
)

const TenantDetailsPage = lazy(() =>
  import('@/pages/platform/TenantDetailsPage').then((m) => ({
    default: m.TenantDetailsPage,
  })),
)

const PlatformPlansPage = lazy(() =>
  import('@/pages/platform/PlatformPlansPage').then((m) => ({
    default: m.PlatformPlansPage,
  })),
)

const PlatformModulesPage = lazy(() =>
  import('@/pages/platform/PlatformModulesPage').then((m) => ({
    default: m.PlatformModulesPage,
  })),
)

const PlatformUsersPage = lazy(() =>
  import('@/pages/platform/PlatformUsersPage').then((m) => ({
    default: m.PlatformUsersPage,
  })),
)

const PlatformReportsPage = lazy(() =>
  import('@/pages/platform/PlatformReportsPage').then((m) => ({
    default: m.PlatformReportsPage,
  })),
)

const PlatformSettingsPage = lazy(() =>
  import('@/pages/platform/PlatformSettingsPage').then((m) => ({
    default: m.PlatformSettingsPage,
  })),
)

export function PlatformRoutes() {
  return (
    <PlatformLayout>
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route index element={<Navigate to="/platform/tenants" replace />} />
          <Route path="tenants"       element={<PlatformTenantsPage />} />
          <Route path="tenants/:id"   element={<TenantDetailsPage />} />
          <Route path="plans"         element={<PlatformPlansPage />} />
          <Route path="modules"       element={<PlatformModulesPage />} />
          <Route path="users"         element={<PlatformUsersPage />} />
          <Route path="settings"      element={<PlatformSettingsPage />} />
          <Route path="reports"       element={<PlatformReportsPage />} />
          <Route path="*"        element={<Navigate to="/platform" replace />} />
        </Routes>
      </Suspense>
    </PlatformLayout>
  )
}
